import React from 'react';
import PropTypes from 'prop-types';
import { Row, Button } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';
import FlightCompanyLogo from '../flightCompanyLogo/FlightCompanyLogo';
import FlightGridDetails from '../flightGridDetails/FlightGridDetails';
import moment from 'moment';
import './FlightSummary.css';
import format from '../../../utils/FormatValue';

bootstrapUtils.addStyle(Button, 'change-search');

var I18n = require('i18n-react').default;

const propTypes = {
  isDeparture: PropTypes.bool.isRequired,
  onChangeFlightClicked: PropTypes.func,
  category: PropTypes.string,
  flight: PropTypes.shape({
    connection: PropTypes.number,
    dateVariation: PropTypes.number,
    elapsedFlightTime: PropTypes.string,
    departureDate: PropTypes.string,
    departureTime: PropTypes.string,
    finalArrivalDate: PropTypes.string,
    finalArrivalTime: PropTypes.string,
    finalDestination: PropTypes.string,
    finalDestinationName: PropTypes.string,
    firstFlightNumber: PropTypes.number,
    flightGroup: PropTypes.arrayOf(PropTypes.object),
    hasExchangeAirport: PropTypes.bool,
    id: PropTypes.number,
    operationCarriers: PropTypes.arrayOf(PropTypes.string),
    originAirport: PropTypes.string,
    originAirportName: PropTypes.string,
    prices: PropTypes.arrayOf(PropTypes.object),
    recommentations: PropTypes.arrayOf(PropTypes.object)
  }),
  throughFlights: PropTypes.number,
  flightDate: PropTypes.string,
  plusDays: PropTypes.number,
  value: PropTypes.number,
  toogleElapsedFlightTime: PropTypes.bool
};

const defaultProps = {
  plusDays: 0,
  throughFlights: 0,
  toogleElapsedFlightTime: false
};

class FlightSummary extends React.Component {
  constructor(props) {
    super(props);
    this.formatValue = this.formatValue.bind(this);
  }

  formatValue(value) {
    const pattern = /\B(?=(\d{3})+(?!\d))/g;
    return value.toString().replace(pattern, '.');
  }

  getIdButtonChangeFlight() {
    if (this.props.isDeparture) {
      return 'departure';
    }
    return 'return';
  }

  renderInfoPoints(value, rangePointsPlusMoney) {
    const points = rangePointsPlusMoney ? rangePointsPlusMoney.points : value;
    const renderPoints = (<span className='FlightSummary_infopoints'>{format.formatPoints(points)}{' ' + I18n.translate('modalSelect.label.points')} </span>);
    if (rangePointsPlusMoney) {
      return (
        <div>
          {renderPoints}
          <span className='FlightSummary_infopartAmount'>{I18n.translate('modalSelect.label.partAmount')}  {format.formatAmount(rangePointsPlusMoney.amount)}</span>
        </div>)
    } else {
      return (
        <div>
          {renderPoints}
        </div>)
    }
  }


  render() {
    const { flight, isDeparture, flightDate, value, category, onChangeFlightClicked, rangePointsPlusMoney } = this.props;

    return (
      <div id={this.props.id} className="FlightSummary">
        <Row>
          <div className="FlightSummary__airport-info">
            <div>
              {I18n.translate(
                isDeparture
                  ? 'components.flightSummary.departureFlightSelected'
                  : 'components.flightSummary.returnFlightSelected'
              )}
            </div>
            <div>
              {flight.originAirportName} ({flight.originAirport})
              <span> {I18n.translate('components.flightSummary.to')} </span>
              {flight.finalDestinationName} ({flight.finalDestination})
            </div>
          </div>
          <div className="FlightSummary__airport-info FlightSummary__airport-info--mobile">
            <div>
              {I18n.translate(
                isDeparture
                  ? 'components.flightSummary.departureFlightSelectedAbbr'
                  : 'components.flightSummary.returnFlightSelectedAbbr'
              )}
            </div>
          </div>
          <div className="FlightSummary__date-info">
            {moment(flightDate, 'DD/MM/YYYY').format('ddd, D MMM YYYY')}
          </div>
          <Button
            id={`btn-change-flight-${this.getIdButtonChangeFlight()}`}
            className="FlightSummary__change-flight"
            bsStyle="change-search"
            onClick={onChangeFlightClicked}>
            {I18n.translate('components.flightSummary.changeThisFlight')}
          </Button>
          <Button
            id={`btn-change-flight-${this.getIdButtonChangeFlight()}-mobile`}
            className="FlightSummary__change-flight FlightSummary__change-flight--mobile"
            bsStyle="change-search"
            onClick={onChangeFlightClicked}>
            {I18n.translate('components.flightSummary.change')}
          </Button>
        </Row>
        <div className="FlightSummary__hr" />
        <Row>
          <FlightCompanyLogo
            id="FlightLogo"
            className="FlightSummary__company-logo"
            flightGroup={flight.flightGroup}
          />
          <FlightGridDetails
            className="FlightSummary__connection-info"
            flightGroup={flight.flightGroup}
            id={`${flight.id}`}
            flightNumber={flight.firstFlightNumber}
            flightConnections={flight.connection}
            throughFlights={flight.throughFlight}
            hasAirportChange={flight.hasExchangeAirport}
            operatingCarriers={flight.operationCarriers}
            elapsedFlightTime={flight.elapsedFlightTime}
            departureFlight={{
              time: flight.departureTime,
              plusDays: null,
              airportSign: flight.originAirport,
              airportName: flight.originAirportName
            }}
            arrivalFlight={{
              time: flight.finalArrivalTime,
              plusDays: flight.dateVariation,
              airportSign: flight.finalDestination,
              airportName: flight.finalDestinationName
            }}
            isCompact={true}
            toogleElapsedFlightTime={this.props.toogleElapsedFlightTime}
          />
          <div className="FlightSummary__points-info">
            {this.renderInfoPoints(value, rangePointsPlusMoney)}

            <div>
              {I18n.translate('components.flightSummary.class')}{' '}
              {I18n.translate(`components.overviewFlight.${category}`)}
            </div>
          </div>
        </Row>
      </div>
    );
  }
}

FlightSummary.propTypes = propTypes;
FlightSummary.defaultProps = defaultProps;

export default FlightSummary;



// WEBPACK FOOTER //
// ./src/components/flightSelection/flightSummary/FlightSummary.jsx